import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { OrdersSelectDropdownProps } from './OrdersSelectDropdown.types';

export const OrdersSelectDropdown: React.FC<OrdersSelectDropdownProps> = ({
  testId,
  value,
  onChange,
  options,
  className,
  onOpenChange,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
    onOpenChange?.();
  };
  return (
    <div className={cn('relative', className)}>
      <select
        data-testid={testId}
        value={value}
        onChange={handleChange}
        className="appearance-none w-full pl-3 pr-7 py-2 text-xs rounded-lg bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-900 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500"
      >
        {options.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
      <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-slate-400 pointer-events-none" />
    </div>
  );
};
